<template>
  <div class="campaigns">
    <div class="inner-content">
      <v-form @submit.prevent="updateProfile" class="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field filled name="first_name" label="Име" type="text" v-validate="'required'"
              v-model="user.first_name" :error-messages="errors.collect('first_name')"
              @keyup.enter="updateProfile"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field filled name="last_name" label="Фамилия" type="text" v-validate="'required'"
              v-model="user.last_name" :error-messages="errors.collect('last_name')"
              @keyup.enter="updateProfile"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field filled name="email" label="Електронна поща" type="text" v-validate="'required|email'"
              v-model="user.email" :error-messages="errors.collect('email')" @keyup.enter="updateProfile"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field filled v-model="user.password" :append-icon="showPass ? 'visibility' : 'visibility_off'"
              :type="showPass ? 'text' : 'password'" name="password" v-validate="'min:6'"
              :error-messages="errors.collect('password')" label="Нова парола" counter
              @click:append="showPass = !showPass"></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isMember">
          <v-col cols="12" md="6">
            <label for="local_organization">Местна организация</label>
            <LocalOrganizationsSelect v-model="user.localOrganization"></LocalOrganizationsSelect>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <label>Известия</label>
            <v-checkbox v-for="(topicName, topic) in topics" :key="`topic-${topic}`" v-model="user.notifications[topic]"
              :label="topicName" color="primary" hide-details></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <label>Мейл известие след гласуване</label>
            <v-checkbox v-model="user.vote_email" label="Да" color="primary" hide-details></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn color="primary" @click="updateProfile" :loading="loading" :disabled="submitDisabled">
              Запази <v-icon class="ml-3">send</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <p style="margin-top: 2rem">
          <a href="" @click.prevent="removeProfile(false)">Оттеглям съгласие за обработка на лични данни</a>
        </p>

        <v-row style="margin-bottom: 2rem">
          <v-col>
            <v-btn color="error" @click.prevent="removeProfile(false)">
              Изтриване на профил <v-icon class="ml-3">delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <Dialog v-model="removing" title="Внимание">
      <div slot="text">
        <p class="subtitle-1">Сигурни ли сте, че искате да изтриете профила си?</p>
      </div>
      <div slot="actions">
        <v-btn color="primary" class="mr-3" @click.prevent="cancelRemoval">Не</v-btn>
        <v-btn color="secondary" text @click.prevent="removeProfile(true)">Да</v-btn>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Dialog from '@/components/Utils/Dialog.vue'
import LocalOrganizationsSelect from '@/components/Users/LocalOrganizationsSelect.vue'

export default {
  name: 'Profile',
  components: { Dialog, LocalOrganizationsSelect },

  mounted() {
    if (this.user.ID) {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getUser', this.user.ID).then(() => {
        this.$store.commit('setLoading', false)
      })
    }
  },

  data() {
    return {
      removing: false,
      showPass: false
    }
  },

  methods: {
    updateProfile() {
      if (this.submitDisabled) return

      this.$store.commit('setLoading', true)

      this.$store.dispatch('updateUser', this.user).then(() => {
        // success
        this.$store.commit('setLoading', false)
      }).catch(() => {
        this.$store.commit('setLoading', false)
      })
    },

    removeProfile(confirmed) {
      if (!confirmed) {
        this.removing = true
        return
      }

      this.removing = false
      this.$store.commit('setLoading', true)

      this.$store.dispatch('removeUser').then(() => {
        // success
        this.$store.commit('setLoading', false)
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/кампании')
        })
      }).catch((error) => {
        console.log('failed', error)
        this.$store.commit('setLoading', false)
      })
    },

    cancelRemoval() {
      this.removing = false
    }
  },

  computed: {
    submitDisabled() {
      return this.loading ||
        this.user.first_name.length === 0 ||
        this.user.last_name.length === 0 ||
        this.user.email.length === 0 ||
        this.errors.items.length > 0
    },
    ...mapGetters(['user', 'isMember', 'topics', 'loading'])
  }
}
</script>
